<template>
  <div class="table-form table-responsive">
    <table class="table">
      <thead>
        <tr>
          <th>Fatura Numarası</th>
          <th>Proforma Numarası</th>
          <th>Toplam Tutar</th>
          <th>Üretim Tarihi</th>
          <th>Üreten Kişi</th>
          <th>İptal Tarihi</th>
          <th>İptal Eden Kişi</th>
          <th>Durum</th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
      <tr v-for="invoice in invoiceList" :key="invoice.id">
        <th>{{ invoice.invoiceId }}</th>
        <th>{{ invoice.proformaInvoiceId }}</th>
        <th>{{ invoice.totalAmount }}</th>
        <th>{{ invoice.createDate | ddMMyyyyHHmmSS }}</th>
        <th> <span v-if="userListMap">{{ userListMap[invoice.createdBy].email}}</span> </th>
        <th v-if="invoice.cancelDate">{{ invoice.cancelDate | ddMMyyyyHHmmSS }}</th>
        <th v-else></th>
        <th v-if="invoice.cancelledBy"><span v-if="userListMap">{{ userListMap[invoice.cancelledBy].email }}</span></th>
        <th v-else></th>
        <th>
          <invoice-status :invoice-status="invoice.status"/>
        </th>
        <th>
          <div @click="downloadInvoice(invoice.documentStoreId)" class="clickable-text">
            <span>İndir</span>
          </div>
        </th>
        <th>
          <div @click="cancelInvoice(invoice.id)" class="clickable-text">
            <span v-if="invoice.status == 'new' || invoice.status == 'paid'">İptal</span>
          </div>
        </th>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped>

.table-form thead th {
  background-color: white;
  color: #1976d2;
}

.theme-btn{
  color: white!important;
}

.clickable-text {
  color: blue !important;
  text-decoration: underline !important;
  cursor: pointer !important;
}
</style>
<script>
import InvoiceStatus from "../common/InvoiceStatus.vue";

export default {
  data () {
    return {
      loading: false
    }
  },
  components: {InvoiceStatus},
  props : {
    invoiceList: null,
  },
  computed:{
    userListMap:{
      get(){
        return this.$store.getters.getUserListMap;
      }
    },
  },
  methods: {
    downloadInvoice(id){
      this.$store.dispatch("downloadInvoice", {id});
    },
    cancelInvoice(id){
      if(this.loading) return;
      this.loading = true;
      this.$store.dispatch("cancelInvoice", id).then((response)=>{
        window.location.reload();
      }).finally(()=>{
        this.loading = false;
      });
    }
  }
}

</script>